import insurance from './insurance';
import checkout from './checkout';
import login from './login';
import signup from './signup';
import user from './user';
import notFound from './notFound';
import support from './support';
import activity from './activity';
import renewal from './renewal';
import partner from './partner';
import help from './help';
const Index = () => import('@/pages/Index');

const index = {
  component: Index,
  name: 'index',
  path: '/', 
  meta: {}
};

const channel = {
  name: 'channel',
  path: '/r/:user/:id'
};

//2019/12/20 Wen add
const channelCar = {
  name: 'channelCar',
  path: '/e/:carno'
};

export default [
  index,
  channel,
  channelCar,
  insurance,
  checkout,
  login,
  signup,
  user,
  support,
  notFound,
  activity,
  help,
  renewal,  //20200827 Wen add
  partner   //20201005 Wen Add 關貿
];